/**
 * Product features mapping for display purposes
 * This complements productConfig with UI-specific feature lists
 */

export const productFeatures = {
  pdf_5k: [
    '12-week structured plan',
    'Beginner to intermediate',
    'PDF download',
  ],
  pdf_10k: [
    '12-week structured plan',
    'Beginner to intermediate',
    'PDF download',
  ],
  pdf_half: [
    '16-week structured plan',
    'Intermediate to advanced',
    'PDF download',
  ],
  pdf_marathon: [
    '20-week structured plan',
    'Intermediate to advanced',
    'PDF download',
  ],
  level_1: [
    'Customized training plan',
    'Monthly plan updates',
    'Email support',
  ],
  level_2: [
    'Everything in Bronze',
    'Bi-weekly plan adjustments',
    'Weekly phone check-ins',
    'Form analysis & feedback',
  ],
  level_3: [
    'Everything in Silver',
    'Weekly 1-on-1 video calls',
    'Real-time plan adjustments',
    'Priority support',
    'Nutrition & recovery guidance',
  ],
  strength_addon: [
    'Runner-specific exercises',
    '2-3 sessions per week',
    'mobility work & progressions',
  ],
  race_strategy_addon: [
    '60-minute strategy session',
    'Personalized pacing plan',
    'Written race strategy document',
  ],
};

